import { render } from "./TSMEditCheck.vue?vue&type=template&id=21dd9e52"
import script from "./TSMEditCheck.vue?vue&type=script&lang=js"
export * from "./TSMEditCheck.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__